export default {
  prepareSequenceImages: Array(33)
    .fill('')
    .map((v, i) =>
      require(`../sequence/QOOKER_Box${i < 10 ? `0${i}` : i}.jpg`)
    ),
    designSliderImage: require('../../../product drawing/Qooker/Storage_box.png'),
    designImageList: [
      {
        number: 1,
        text: '-a',
        side: 'BOTTOM',
        image: require('../../../parts/storage_box/1a.png'),
      },
      {
        number: 1,
        text: '-b',
        side: 'MIDDLE',
        image: require('../../../parts/storage_box/1b.png'),
      },
      {
        number: 1,
        text: '-c',
        side: 'TOP',
        image: require('../../../parts/storage_box/1c.png'),
      },
      {
        number: 2,
        // text: "❷",
        side: 'RIGHT',
        image: require('../../../parts/storage_box/2.png'),
      },
      {
        number: 3,
        // text: "❸",
        side: 'LEFT',
        image: require('../../../parts/storage_box/3.png'),
      },
      {
        number: 4,
        // text: "❹",
        side: 'BACK',
        image: require('../../../parts/storage_box/4.png'),
      },
    ],
    cutOutPartsImage: require('../../../parts/storage_box/❶-c.png'),
  assembleSequenceImages: Array(47)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/02_storage_sequence/storage${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),

  completeImage: require('../../../complete/storage_box.png'),
  completeImagePc: require('../../../complete/storage_box.png'),
};
